'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGNMENT_CLASSES = exports.ALIGNMENT_CLASSES = {
  start: '',
  baseline: 'private-checkbox--align-baseline',
  center: 'private-checkbox--align-center',
  end: 'private-checkbox--align-end'
};

var PADDING_OPTIONS = exports.PADDING_OPTIONS = {
  default: '',
  none: 'private-checkbox--flush'
};

var SIZE_OPTIONS = exports.SIZE_OPTIONS = {
  default: '',
  small: 'private-checkbox--small'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/input/CheckboxConstants.js
// module id = 309
// module chunks = 0